export const GlobalDocumentIds = {
  genericPageTemplate: 'content-to-be-hidden-from-screen-readers-when-modal-is-open',
  instantSearch: 'instant-search',
  mainNavigation: 'navigation',
  mainNavigationPanel: 'main-navigation-panel',
  mainNavigationSubPanelContainer: 'main-navigation-sub-panel-container',
  mainNavigationSubPanel: 'main-navigation-sub-panel-', // comes with count per panel
  mainNavigationBox: 'navigation-box',
  mainContent: 'maincontent',
  mainContentWrapper: 'main-content-wrapper',
  scrollContent: 'scroll-content', // needed for ReturnToTopArrow
  scrollTopAnchor: 'scroll-top-anchor',
  loadingFeedback: 'loading-feedback',
  breadcrumb: 'breadcrumb',
  pageTitle: 'page-title',
  pageManagement: 'page-management',
  pageManagementHeadline: 'page-management-headline',
  addContentBlock: 'add-content-block',
  pagination: 'pagination',
  personal: 'personal',
  personalBox: 'personal-box',
  modalDialog: 'modal-dialog',
  palContainer: 'pal-container',
  root: 'root',
  ssrCompositionJson: 'ssr-composition-json',
  connectedPagesViewContainer: 'connected-pages-view-container',
} as const;

export type GlobalDocumentIds = (typeof GlobalDocumentIds)[keyof typeof GlobalDocumentIds];
